import {
  ORG_SETTINGS_TRADE_CATEGORIES,
  ORG_SETTINGS_TRADE_DEFINITIONS,
} from '@kaiizen/kai-pro-api';

export type InputsTradeSeed = {
  slug: string;
  displayName: string;
  category: string;
};

export const INPUTS_TRADE_SEEDS: readonly InputsTradeSeed[] = ORG_SETTINGS_TRADE_DEFINITIONS.map(({ key, displayName, category }) => ({
  slug: key,
  displayName,
  category,
}));

export const INPUTS_TRADE_CATEGORIES = ORG_SETTINGS_TRADE_CATEGORIES;
